module.exports = __webpack_public_path__ + "images/home-selected48ef01a6751c58d5168d7150db48ed7a.png";